import { call, put, takeLatest } from 'redux-saga/effects';
import {
  goToSocialRegistrationAction,
  loginAction,
  loginErrorAction,
  loginSuccessAction,
} from '../../store/auth/login.store';
import { ApiResponse } from '../../api/request';
import {
  changePasswordAPI,
  completeRegistrationAPI, confirmResetPasswordAPI,
  loginAPI,
  loginSocialAPI,
  logoutAPI,
  meAPI,
  registrationCustomerAPI,
  resetPasswordAPI,
} from '../../api/provider/auth/auth-provider';
import {
  ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, removeStringFromStorageGenerator,
  writeStringToStorageGenerator,
} from '../../utils/local-storage';
import {
  completeRegistrationAction,
  completeRegistrationErrorAction,
  completeRegistrationSuccessAction,
  registrationCustomerAction, registrationCustomerErrorAction, registrationCustomerSuccessAction
} from "../../store/auth/registration.store";
import { userSetDataAction, UserTypeVariant } from '../../store/user.store';
import { logoutAction, logoutErrorAction, logoutSuccessAction } from '../../store/auth/logout.store';
import { changePasswordAction,changePasswordSuccessAction,changePasswordErrorAction} from "../../store/auth/password-change.store";
import {
  confirmResetPasswordAction, confirmResetPasswordSuccessAction,
  resetPasswordAction,
  resetPasswordErrorAction,
  resetPasswordSuccessAction
} from '../../store/auth/reset-password.store';
import { authenticatedCall } from '../../utils/authenticated-call';
function* loginSaga(data: any) {

  let responseLogin: ApiResponse | null = null
  let meResult: ApiResponse | null = null
  let userType: UserTypeVariant | null = null
  let navigationPage: string | null = null

  try {
    if (data.payload.isSocialLogin) {
      responseLogin = yield call(loginSocialAPI, data.payload.dataToSend)
    } else {
      responseLogin = yield call(loginAPI, data.payload)
    }
    writeStringToStorageGenerator(ACCESS_TOKEN_KEY, responseLogin?.data.access_token)
    writeStringToStorageGenerator(REFRESH_TOKEN_KEY, responseLogin?.data.refresh_token)
    meResult = yield call(meAPI)
    yield put(userSetDataAction(meResult?.data.data))
    userType = meResult?.data.data.user_type
    navigationPage = userType === 'Admin' ? '/admin/all-events' : '/customer/booking'
  } catch (error: any) {
    if (error.config?.url === '/api/auth/social/token' && error.statusCode === 400) {
      yield put(goToSocialRegistrationAction())
    } else {
      yield put(loginErrorAction(error.localizedMessage))
    }
    return
  }

  yield put(loginSuccessAction(navigationPage));
}

function* registrationCustomerSaga(data: any) {
  try {
    yield call(registrationCustomerAPI, data.payload);
    yield put(registrationCustomerSuccessAction());
  } catch (error: any) {
    yield put(registrationCustomerErrorAction(error.localizedMessage))
  }
}

function* changePasswordSaga(data: any) {
  try {
    yield authenticatedCall(changePasswordAPI, data.payload);
    yield put(changePasswordSuccessAction());
  } catch (error: any) {
    yield put(changePasswordErrorAction(error.localizedMessage))
  }
}

function* completeRegistrationSaga(data: any) {
  try {
    yield call(completeRegistrationAPI, data.payload);
    yield put(completeRegistrationSuccessAction());
  } catch (error: any) {
    yield put(completeRegistrationErrorAction(error.localizedMessage))
  }
}

function* resetPasswordSaga(data: any) {
  try {
    yield call(resetPasswordAPI, data.payload)
    yield put(resetPasswordSuccessAction())
  } catch (error: any) {
    yield put(resetPasswordErrorAction(error.localizedMessage))
  }
}

function* confirmResetPasswordSaga(data: any) {
  try {
    yield call(confirmResetPasswordAPI, data.payload)
    yield put(confirmResetPasswordSuccessAction())
  } catch (error: any) {
    yield put(resetPasswordErrorAction(error.localizedMessage))
  }
}

function* logoutSaga() {
  try {
    yield call(logoutAPI)
    removeStringFromStorageGenerator(ACCESS_TOKEN_KEY)
    removeStringFromStorageGenerator(REFRESH_TOKEN_KEY)
    yield put(logoutSuccessAction())
  } catch (error: any) {
    yield put(logoutErrorAction(error.localizedMessage))
  }
}

export function* authSagas() {
  yield takeLatest(loginAction.type, loginSaga);
  yield takeLatest(registrationCustomerAction.type, registrationCustomerSaga);
  yield takeLatest(logoutAction.type, logoutSaga);
  yield takeLatest(changePasswordAction.type, changePasswordSaga);
  yield takeLatest(completeRegistrationAction.type, completeRegistrationSaga);
  yield takeLatest(resetPasswordAction.type, resetPasswordSaga);
  yield takeLatest(confirmResetPasswordAction.type, confirmResetPasswordSaga);
}
